import React from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import i18n from "../../../constants/i18n";
import getInvestigationCasesStore from "../../../stores/investigation-cases-store";
import Et3Button from "../../../core/et3-button";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../core/et3-div";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import Et3TextInput from "../../../core/et3-input/et3-text-input";
import { COUTRIES_GROUP_PICKER_ENTRIES } from "../../../constants/picker-entries-constants";
import Et3Picker from "../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

const InvestigationCasesForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  const data = getInvestigationCasesStore().investigationCases.get();
  const dataExist = data.length > 0;
  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("COUNTRY_CREATED_FROM")}
          options={COUTRIES_GROUP_PICKER_ENTRIES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getInvestigationCasesStore().setInvestigationCaseCreatedFromType(
              value
            );
          }}
          value={getInvestigationCasesStore().createdFromType.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"text"}
          icon={faLock}
          label={i18n.get("LIMIT")}
          placeHolder={i18n.get("LIMIT")}
          value={getInvestigationCasesStore().investigationCasesLimit.get()}
          onChoose={() => {}}
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={1200}
        height={45}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={true}
          onClick={async () => {
            await getInvestigationCasesStore().getData({
              withURLSearch: false
            });
          }}
          text="GET"
          size="LARGE"
          type="GET"
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Button
          isEnabled={dataExist}
          onClick={() => {
            getInvestigationCasesStore().cleanPool();
          }}
          size="LARGE"
          type="REJECT"
          text="CLEAN_POOL"
        >
          {i18n.get("CLEAN_POOL")}
        </Et3Button>
      </ET3Div>
    </React.Fragment>
  );
});

export default InvestigationCasesForm;
